import { z } from 'zod';
import { apiClient } from './api-client';
import {
    CurrentHangoutSchema,
    HangoutSummariesSchema,
    ResultsSchema,
    MyEntrySchema,
    StandingsSchema,
    type Hangout,
    type HangoutSummary,
    type MyEntry,
    type Result,
    type Standing,
} from '../schemas/hangout.schema';

export const AllTimeRowSchema = z.object({
    userId: z.number().int().positive(),
    handle: z.string(),
    played: z.number().int(),
    wins: z.number().int(),
    tokens: z.number().int(),
    best: z.number().int(),
    roi: z.number(),
});
const AllTimeSchema = z.array(AllTimeRowSchema);
export type AllTimeRow = z.infer<typeof AllTimeRowSchema>;

export const hangoutsService = {
    list: (): Promise<HangoutSummary[]> => apiClient.get('hangouts', HangoutSummariesSchema),

    results: (hangoutId: number): Promise<Result[]> =>
        apiClient.get(`hangouts/${hangoutId}/results`, ResultsSchema),

    allTime: (): Promise<AllTimeRow[]> => apiClient.get('hangouts/all-time', AllTimeSchema),

    current: (): Promise<Hangout | null> => apiClient.get('hangouts/current', CurrentHangoutSchema),



    standings: (hangoutId: number): Promise<Standing[]> =>
        apiClient.get(`hangouts/${hangoutId}/standings`, StandingsSchema),

    myEntry: (hangoutId: number): Promise<MyEntry> =>
        apiClient.get(`hangouts/${hangoutId}/me`, MyEntrySchema),
};
